module.exports = __webpack_public_path__ + "static/media/ckn_pedidos_filtros_dos.33cfad41.jpg";